module.exports = __webpack_public_path__ + "img/anquan2-4.b729c294.jpg";